import { useRouter } from 'next/router';

export const useBookingSteps = () => {
  const router = useRouter();

  const navigateToNextStep = ({
    stepKey,
    action,
  }: {
    stepKey: string;
    action?: 'reschedule';
  }) => {
    const actionQuery = action ? `&action=${action}` : '';

    void router.push(
      `${router.pathname}?step=${stepKey}${actionQuery}`,
      undefined,
      {
        shallow: true,
      },
    );
  };

  return { navigateToNextStep };
};
